<script setup lang="ts">
defineOptions({ name: 'AuthRememberedUser' })
import { useSso } from '../sso'

const { rememberedUser, selectRememberedUser, useAnotherAccount } = useSso()
</script>

<template>
  <div class="sso-form">
    <h2 class="sso-section-title">Оберіть обліковий запис</h2>

    <v-list-item
      v-if="rememberedUser"
      border
      class="pa-4"
      color="primary"
      :disabled="$loading.isLoading('checkEmail')"
      rounded="lg"
      role="button"
      :subtitle="rememberedUser.name ? rememberedUser.email : undefined"
      :title="rememberedUser.name || rememberedUser.email"
      @click="selectRememberedUser">
      <template #prepend>
        <v-avatar color="primary" size="40">
          <span>{{ rememberedUser.initials }}</span>
        </v-avatar>
      </template>
      <template #append>
        <v-progress-circular
          v-if="$loading.isLoading('checkEmail')"
          color="primary"
          indeterminate
          size="20"
          width="2"></v-progress-circular>
        <v-icon v-else icon="mdi-chevron-right"></v-icon>
      </template>
    </v-list-item>

    <v-btn
      block
      color="primary"
      :disabled="$loading.isLoading('checkEmail')"
      variant="text"
      @click="useAnotherAccount">
      Інший обліковий запис
    </v-btn>
  </div>
</template>
